import CONSTANTS from '@/constants'
import { CONTENT } from '@/services/axios.config'
import buildParamList from './utils/build_params'
import { buildServices } from './utils/build_services'

const services = [
  {
    name: 'listVendorCertifications',
    method: 'get',
    url: (params) => `/external-vendor-certifications${buildParamList(params)}`
  },
  {
    name: 'createVendorCertification',
    method: 'post',
    url: () => `/external-vendor-certifications`,
    data: (params) => ({
      vendor: params.vendor,
      certification_name: params.certificationName,
      status: params.status || CONSTANTS.CERTIFICATION_STATUSES.PUBLISHED
    })
  }
]

export const {
  listVendorCertifications,
  createVendorCertification
} = buildServices(CONTENT, services)
